import { Instance, types } from 'mobx-state-tree';
import { Partner } from '@constants/paymentLink';
import { CARD_PARTNER, CASH_PARTNER, DIRECT_DEBIT_PARTNER, SPEI_PARTNER } from '@configs/payment';

const getPaymentMethod = (defaultMethod: Partner) => {
  return types
    .model({
      enabled: types.optional(types.boolean, false),
      publicApiKey: '',
      merchantId: '',
      partner: '',
      platformId: '',
      apiKey: '',
      workspaceId: '',
      walletId: '',
      connectedAccountId: '',
    })
    .views((self) => ({
      get isPartnerKushki() {
        return self.partner === Partner.KUSHKI;
      },
      get isPartnerDlocal() {
        return self.partner === Partner.DLOCAL;
      },
      get isPartnerOpenPay() {
        return self.partner === Partner.OPENPAY;
      },
      get isPartnerOyster() {
        return self.partner === Partner.OYSTER;
      },
      get isPartnerArcus() {
        return self.partner === Partner.ARCUS;
      },
      get isPartnerFiserv() {
        return self.partner === Partner.FISERV;
      },
      get isPartnerBlumon() {
        return self.partner === Partner.BLUMON;
      },
      get isPartnerRedPay() {
        return self.partner === Partner.REDPAY;
      },
      get isPartnerBelvo() {
        return self.partner === Partner.BELVO;
      },
      get isPartnerStripe() {
        return self.partner === Partner.STRIPE;
      },
      get isAddressRequired() {
        return (
          self.partner === Partner.FISERV ||
          self.partner === Partner.BLUMON ||
          self.partner === Partner.REDPAY ||
          self.partner === Partner.KUSHKI
        );
      },
    }));
};

const PaymentConfig = types.model({
  paymentMethods: types.optional(
    types.model({
      card: types.optional(getPaymentMethod(CARD_PARTNER), {}),
      cash: types.optional(getPaymentMethod(CASH_PARTNER), {}),
      spei: types.optional(getPaymentMethod(SPEI_PARTNER), {}),
      directDebit: types.optional(getPaymentMethod(DIRECT_DEBIT_PARTNER), {}),
    }),
    {},
  ),
});

export interface PaymentConfigStore extends Instance<typeof PaymentConfig> {}
export default PaymentConfig;
